import { GameType as GameTypeEnum } from '@/models/games/enums/GameType';
import { tableBetSliceActions } from '@/modules/betTable/slice';
import { getIsGoodRoad, goodRoadsSliceActions } from '@/modules/goodRoad/slice';
import { hostLiveSliceActions } from '@/modules/hostLive/slice';
import { LiveDataSliceActions } from '@/modules/main/slice/liveData';
import { bj2HandSliceActions } from '@/modules/rwdGame/blackjack2/slice/handSlice';
import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { batch } from 'react-redux';
import { getHostById, hostsSliceActions } from '../../../modules/host/slice';
import store from '../../../store/store';
import { GameState } from '../../games/enums/GameState';
import { CMDScShuffle, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';

export class CMDScShuffleHandler extends AbstractHandler {
    _command: CMDScShuffle;

    constructor(command: ICommand) {
        super();
        this._command = command as CMDScShuffle;
    }

    override handle(dispatch: Dispatch<AnyAction>): void {
        const hostId = this._command.HostID;
        const state = store.getState();
        const host = getHostById(state, this._command.HostID); //getHostByGameId(state, gameState.currentGameId);
        const goodRoad = getIsGoodRoad(state, this._command.HostID);
        batch(() => {
            if (goodRoad && goodRoad.isGoodRoad) {
                goodRoadsSliceActions.update({
                    HostId: this._command.HostID,
                    isGoodRoad: false,
                    isRest: goodRoad.isRest,
                });
            }
            dispatch(
                hostsSliceActions.updateRecord({
                    hostId,
                    record: [],
                    gameType: host.GameType,
                })
            );
            dispatch(
                hostLiveSliceActions.updateGameCount({
                    hostId,
                    gameCount: 0,
                })
            );
            dispatch(
                tableBetSliceActions.clearBets({
                    hostId: this._command.HostID,
                    gameId: 0,
                })
            );
            dispatch(
                LiveDataSliceActions.updateHostBetInfo({
                    hostId: host.HostId,
                    totalBetAmount: 0,
                    totalWithHoldAmount: 0,
                    pendingBetAmount: 0,
                    pendingWithHoldAmount: 0,
                })
            );
            dispatch(
                hostLiveSliceActions.updateGameState({
                    hostId,
                    state: GameState.Shuffle,
                })
            );
            if (host.GameType === GameTypeEnum.Blackjack2) {
                dispatch(bj2HandSliceActions.reset(host.HostId));
            }
        });
    }
}
